import React from "react";

interface CopyProps {
    onClick: () => void;
}

export const Copy: React.FC<CopyProps> = ({ onClick }) => {
    return (
        <div onClick={ onClick } className="cursor-pointer">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4 2.9H3.9V3V16.9H2.1V3C2.1 1.95523 2.95523 1.1 4 1.1H15.9V2.9H4ZM19 21.1H19.1V21V7V6.9H19H8H7.9V7V21V21.1H8H19ZM8 5.1H19C20.0448 5.1 20.9 5.95523 20.9 7V21C20.9 22.0448 20.0448 22.9 19 22.9H8C6.95523 22.9 6.1 22.0448 6.1 21V7C6.1 5.95523 6.95523 5.1 8 5.1Z"
                    fill="#949494" stroke="white" strokeWidth="0.2"/>
            </svg>
        </div>
    )
}